import React from 'react';
import { Col } from 'react-bootstrap';
import { Field } from 'redux-form';
import SelectField from '../../../../../../common/components/ReduxFormField/SelectField';
import { FormGroupRow, InfoLabel } from '../../../../../../common/components';
import CheckboxGroup from '../../../../../../common/components/ReduxFormField/CheckboxGroup';

const parseIOMAutoInclude = (value) => {
  if (value) {
    return {
      postcode_type: 'uk',
    };
  }
  return null;
};
const parseCoverLevelIOMAutoInclude = (value) => {
  if (value) {
    return {
      cover_level: 'Gold',
      postcode_type: 'uk',
    };
  }
  return null;
};
const formatIOMAutoInclude = (value) => {
  return !!value;
};
const formatCoverLevelIOMAutoInclude = (value) => {
  return !!value;
};

const parseIOMExclusion = (value) => {
  if (value) {
    return {
      postcode_type: 'uk_and_balliwicks',
    };
  }
  return null;
};
const formatIOMExclusion = (value) => {
  return !!value;
};

const EnableBoltonField = ({ input, label, labelSize, fieldSize }) => {
  return (
    <FormGroupRow label={label} labelSize={labelSize} fieldSize={fieldSize}>
      <Field
        name={`${input.name}`}
        component={CheckboxGroup}
        options={[{ label: '', value: true }]}
      />
    </FormGroupRow>
  );
};

const ViewEnabled = ({ input, label }) => {
  return (
    <InfoLabel
      label={`${label} ${input.value ? 'enabled' : 'disabled'}`}
      labelSize={12}
      value={''}
    />
  );
};

const AutoIncludeField = ({ label, input, coverLevels, labelSize, fieldSize }) => {
  if (coverLevels) {
    return (
      <FormGroupRow label={label} labelSize={labelSize} fieldSize={fieldSize}>
        <Field
          name={`${input.name}`}
          component={SelectField}
          isMulti
          options={coverLevels?.map((coverLevel) => ({
            label: coverLevel,
            value: coverLevel,
          }))}
        />
      </FormGroupRow>
    );
  }
  return (
    <FormGroupRow label={label} labelSize={labelSize} fieldSize={fieldSize}>
      <Field
        name={`${input.name}`}
        component={CheckboxGroup}
        options={[{ label: '', value: true }]}
      />
    </FormGroupRow>
  );
};
const ViewAutoInclude = ({ input }) => {
  if (Array.isArray(input?.value)) {
    return (
      <InfoLabel
        label={'Auto Include On: ' + input.value?.join(', ')}
        value={''}
        labelSize={12}
      />
    );
  }
  return (
    <InfoLabel
      label={`Auto Include: ${input.value ? 'Yes' : 'No'}`}
      value={''}
      labelSize={12}
    />
  );
};

const IOMExclusionField = ({ input, label, labelSize, fieldSize }) => {
  return (
    <FormGroupRow label={label} labelSize={labelSize} fieldSize={fieldSize}>
      <Field
        name={`${input.name}`}
        parse={parseIOMExclusion}
        format={formatIOMExclusion}
        noFormGroup
        component={CheckboxGroup}
        options={[{ label: '', value: true }]}
      />
    </FormGroupRow>
  );
};

const ViewIOMExclusion = ({ input, label }) => {
  return (
    <InfoLabel
      label={`${label} ${input.value ? 'enabled' : 'disabled'}`}
      labelSize={12}
      value={''}
    />
  );
};

const AutoIncludeUKField = ({ input, labelSize, fieldSize, coverLevels }) => {
  const hasCoverLevel = !!coverLevels?.length;
  const label = hasCoverLevel
    ? 'Auto include on Gold for UK Only:'
    : 'Auto include on UK Only:';
  return (
    <FormGroupRow label={label} labelSize={labelSize} fieldSize={fieldSize}>
      <Field
        name={`${input.name}`}
        parse={hasCoverLevel ? parseCoverLevelIOMAutoInclude : parseIOMAutoInclude}
        format={hasCoverLevel ? formatCoverLevelIOMAutoInclude : formatIOMAutoInclude}
        noFormGroup
        component={CheckboxGroup}
        options={[{ label: '', value: true }]}
      />
    </FormGroupRow>
  );
};

const ViewAutoIncludeUK = ({ input, coverLevels }) => {
  const hasCoverLevel = !!coverLevels?.length;
  const label = hasCoverLevel
    ? 'Auto include on Gold for UK Only:'
    : 'Auto include on UK Only:';
  const coverLevel = input.value?.cover_level;
  if (coverLevel) {
    return (
      <InfoLabel
        label={`${label} ${coverLevel ? 'Yes' : 'No'}`}
        labelSize={12}
        value={''}
      />
    );
  }

  return (
    <InfoLabel
      label={`${label}   ${input.value ? 'Yes' : 'No'}`}
      labelSize={12}
      value={''}
    />
  );
};

const OptionAncillary = ({ input, isViewOnly, coverLevels }) => {
  const name = input.name;

  return (
    <>
      <Col sm={6}>
        <Field
          isViewOnly={isViewOnly}
          name={`${name}.bolt_on`}
          label={isViewOnly ? 'Bolt On:' : 'Enable Bolt On'}
          labelSize={4}
          fieldSize={2}
          component={isViewOnly ? ViewEnabled : EnableBoltonField}
          coverLevels={coverLevels}
        />
      </Col>
      <Col sm={6}>
        <Field
          isViewOnly={isViewOnly}
          name={`${name}.exclusion`}
          label={isViewOnly ? 'IOM Exclusion:' : 'Exclude from upgrades if not in UK:'}
          labelSize={4}
          fieldSize={2}
          component={isViewOnly ? ViewIOMExclusion : IOMExclusionField}
          coverLevels={coverLevels}
        />
      </Col>
      <Col sm={6}>
        <Field
          isViewOnly={isViewOnly}
          name={`${name}.auto_include`}
          label={'Auto Include:'}
          labelSize={4}
          fieldSize={4}
          component={isViewOnly ? ViewAutoInclude : AutoIncludeField}
          coverLevels={coverLevels}
        />
      </Col>
      <Col sm={6}>
        <Field
          isViewOnly={isViewOnly}
          name={`${name}.conditional_auto_include`}
          labelSize={4}
          fieldSize={2}
          coverLevels={coverLevels}
          component={isViewOnly ? ViewAutoIncludeUK : AutoIncludeUKField}
        />
      </Col>
    </>
  );
};

export default OptionAncillary;
